import React, { useState, useEffect } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Swal from "sweetalert2";
import CustomPagination from "../../common/custompagination";
import Sorting from "../../common/sorting";
import Loader from "../../common/loader";
import Breadcrums from "../../common/breadcrumbs";
import $ from "jquery";
import {
  SWAL_SETTINGS,
  THEME_COLORS,
  showFilterlistByUser,
  showFilterlistForActivationAndDeactivation
} from "../../../../utils/Constants";
import {
  capitalizeFirstLetter,

  formatDateWithTime,

  formateDateWithMonth,

  handleServerValidations,

  TrimText,
} from "../../../../utils/commonfunction";
import StatusFilter from "../../common/statusFilter";
import CustomRangepicker from "../../common/rangepicker";
import { List, ChangeActivationStatus, Delete , ChangeStatus } from "../../services/babeuser.services"
import { Dropdown, Placeholder, Tooltip, Whisper } from "rsuite";
import { usePermission } from '../../../../utils/commonfunction';

const BabeUserTable = () => {
  const { t } = useTranslation();
  const params = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const { can } = usePermission();
  const [list, setList] = useState([]);
  const [statsupdate, setStatusUpdate] = useState("false");
  const [datalength, setDataLength] = useState("");
  const [itemperpage] = useState(10);
  const [sorting, setSorting] = useState({});
  const [defaultSorting, setDefaultSorting] = useState(true);
  const [page, setPage] = useState(1);
  const [loader, setLoader] = useState(true);
  const [search, setSearch] = useState({});
  const [globalsearch, setGlobalSearch] = useState("");
  const breadcrumbs = [
    { title: t("sidebar_link_dashboard"), url: "/admin/dashboard" },
    { title: t("label_users"), url: "" },
  ];
  const [resetdate, setResetDate] = useState(false);
  const [statusUpdated, setStatusUpdated] = useState(false)






  /********** MULTI SELECT <<<<<<********* */

  useEffect(() => {
    const getData = setTimeout(() => {
      if (search) {
        setLoader(true);
        const formData = new FormData();
        formData.append("page", params.pgno);
        formData.append("per_page", itemperpage);
        formData.append("sort", JSON.stringify(sorting));
        formData.append("search", JSON.stringify(search));
        formData.append("global_search", globalsearch);
        List(formData)
          .then((data) => {
            setDataLength(data.data.total_records);
            // setSerialNo(data.data.offset);
            setList(data && data.data && data.data.list ? data.data.list : []);

            setPage(data && data.data && data.data.page ? data.data.page : 1);
            setLoader(false);
          })
          .catch((error) => {
            console.log("error ====> ", error);
          });
      }
    }, 300);
    return () => clearTimeout(getData)
  }, [
    location,
    statsupdate,
    sorting,
    search,
    globalsearch,
    itemperpage,
    params.pgno,
    statusUpdated
  ]);

  const viewfunction = (row) => {
    navigate(
      `/admin/babe-user/view/${row._id}`
    );
  };

  // sorting function start
  const handleSort = (e, column) => {
    setDefaultSorting(false);
    let sort = { order: 0, column: column };
    if (e.target.classList.contains("assc")) {
      sort.order = -1;
    } else {
      sort.order = 1;
    }
    setSorting(sort);
  };
  // sorting end

  // search or filter function
  const prepareSearch = (key, value) => {
    let sr = { ...search };
    if (String(value).length > 0) {
      sr[key] = value;
    } else {
      delete sr[key];
    }
    setSearch(sr);
  };

  // search or activation and inactivation function
  const prepareSearchBaseOnActiveAndInactive = (key, value) => {
    let sr = { ...search };
    if (value != null && value !== "") {
      sr['isUserDeactivated'] = Boolean(value);
    } else {
      delete sr['isUserDeactivated'];
    }
    setSearch(sr);
  };


  const resetFilter = (e) => {
    e.preventDefault();
    setGlobalSearch("");
    prepareSearch();
    setSearch({});
    setResetDate(!resetdate);
    $("#defaultstatus")[0].selectedIndex = 0;
  };


  const goToEdit = (row) => {
    navigate(
      `/admin/babe-user/edit/${row._id}`
    );
  };

  const changeStatusToggle = (row) => {
    Swal.fire({
      title: t("msg_are_you_sure"),
      text: row.status === 1 ? t("user_block_text") : t("user_unblock_text"),
      // imageUrl: trash,
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: THEME_COLORS.ADMIN_PRIMARY,
      cancelButtonColor: "#000",
      confirmButtonText: row.status === 1 ? t("btn_block") : t("btn_unblock"),
      cancelButtonText: t("btn_cancel"),
      // reverseButtons: true,
      // customClass: {
      //   popup: "swal-restaurant",
      //   confirmButton: "btn btn-success col",
      //   cancelButton: "btn btn-danger col",
      // },
      // allowOutsideClick: false,
    }).then((result) => {
     
      if (result.isConfirmed) {
        setStatusUpdated(!statusUpdated)
        ChangeStatus({ _id: row._id, status: row.status === 1 ? 0 : 1 })
          .then((response) => {

            if (response.success) {
              Swal.fire({
                icon: "success",
                text: response.message,
                ...SWAL_SETTINGS,
              });

            } else {
              Swal.fire({
                icon: "error",
                text: handleServerValidations(response),
                ...SWAL_SETTINGS,
              });
            }
          })
          .catch((error) => {

            console.log("deleteError");
          });
      } else {
        // setSortableCategories(List);
      }
    });
  };

  const changeActivationToggle = (row) => {
    Swal.fire({
      title: t("msg_are_you_sure"),
      text: row.isUserDeactivated? t("user_InActive_text") : t("user_Active_text"),
      // imageUrl: trash,
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: THEME_COLORS.ADMIN_PRIMARY,
      cancelButtonColor: "#000",
      confirmButtonText: row.isUserDeactivated ? t("btn_inactive") : t("btn_active"),
      cancelButtonText: t("btn_cancel"),
      // reverseButtons: true,
      // customClass: {
      //   popup: "swal-restaurant",
      //   confirmButton: "btn btn-success col",
      //   cancelButton: "btn btn-danger col",
      // },
      // allowOutsideClick: false,
    }).then((result) => {
     
      if (result.isConfirmed) {
        setStatusUpdated(!statusUpdated)
        ChangeActivationStatus({ _id: row._id, status: row.isUserDeactivated })
          .then((response) => {

            if (response.success) {
              Swal.fire({
                icon: "success",
                text: response.message,
                ...SWAL_SETTINGS,
              });

            } else {
              Swal.fire({
                icon: "error",
                text: handleServerValidations(response),
                ...SWAL_SETTINGS,
              });
            }
          })
          .catch((error) => {

            console.log("deleteError");
          });
      } else {
        // setSortableCategories(List);
      }
    });
  };


  const Deletefunction = (row) => {

    Swal.fire({
      customClass: 'swal-wide',
      title: t("msg_are_you_sure"),
      text: t("you_not_be_able_to_revert_this"),
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: THEME_COLORS.ADMIN_PRIMARY,
      cancelButtonColor: "#000",
      confirmButtonText: t("btn_yes_delete"),
      cancelButtonText: t("btn_cancel")
    }).then((result) => {
      if (result.isConfirmed) {
        let id = row._id;
        const formdata = new FormData();

        Delete({ _id: row._id }).then(response => {
          setStatusUpdate(!statsupdate)
          if (response.success) {
            Swal.fire({
              icon: 'success',
              text: response.message,
              ...SWAL_SETTINGS
            })

          } else {
            Swal.fire({
              icon: 'error',
              text: handleServerValidations(response),
              ...SWAL_SETTINGS
            })
          }
        }).catch((error) => {
          console.log("deleteError", error)
        });
      }
    })
  }


  

  //  const formatDateWithTime = (createdAt) => {
  //       const date = new Date(createdAt);
  //       const formattedDate = date.toLocaleDateString();
  //       const formattedTime = date.toLocaleTimeString().substring(0,5);
  //       return `${formattedDate} ${formattedTime}`
  //  }

  return (
    <>
      <Breadcrums data={breadcrumbs} />
      {/* table section */}
      <div className="animation_fade">
        <div className="card custom-card">
          <div className="card-body">
            <div className="d-flex justify-content-between align-items-center mb-4">
              <h6 className="main-content-label">
                {t("label_users")}
              </h6>
              <div className="d-flex align-items-center">
                <div className="form-group mb-0 me-3">
                  <div className="form-group mb-0 rangepicker_container filter_design">
                    <i className="fa fa-search calender_icon"></i>
                    <input
                      type="search"
                      className="form-control"
                      value={globalsearch}
                      placeholder={t("input_placeholder_search")}
                      onChange={(e) => {
                        setGlobalSearch(e.target.value);
                      }}
                    />
                  </div>
                </div>
                {/* <div className="me-3">
                  <CustomRangepicker
                    GetDateRange={(e) => {
                      prepareSearch("createdAt", e);
                    }}
                    resetdate={resetdate}
                  />
                </div> */}
                <div className="me-3">
                  <StatusFilter
                    data={showFilterlistByUser}
                    prepareSearch={prepareSearch}
                  />
                </div>
                <div className="me-3">
                  <StatusFilter
                    data={showFilterlistForActivationAndDeactivation}
                    prepareSearch={prepareSearchBaseOnActiveAndInactive}
                  />
                </div>
                <button
                  type="reset"
                  value="Reset"
                  onClick={resetFilter}
                  className="btn ripple btn-main-primary signbtn"
                >
                  {t("btn_reset_filter")}
                </button>
              </div>
            </div>
            {
              loader?
              <Placeholder.Paragraph className="w-100 admin-placeholder" rowHeight={30} rowSpacing={5} active={true} rows={7}/>
              : <>
              <div className="table-responsive min-h-400">
                <table className="table table-bordered card-table border-top text-nowrap w-100">
                  <thead>
                    <tr>
                      <th className="position-relative select_head">
                        <span>{t("list_heading_sno")}</span>
                      </th>
                      <th>
                        <div className="sorting_column">
                          <span>{t("label_name")}</span>
                          <Sorting
                            sort={sorting}
                            handleSort={handleSort}
                            column="name"
                          />
                        </div>
                      </th>

                      <th>{t("label_email")}</th>
                      <th>
                        <div className="sorting_column">
                          <span>{t("list_heading_address")}</span>
                          <Sorting
                            sort={sorting}
                            handleSort={handleSort}
                            column="location"
                          />
                        </div>
                      </th>

                      <th className="">{t("label_phone_number")}</th>
                      <th className="status_head">{t("list_heading_account_blocked")}</th>    
                      {/* <th className="status_head">{t("list_heading_activation_status")}</th>    */}
                      <th className="created_head">
                        <div className="sorting_column">
                          <span>{t("list_heading_created_date")}</span>
                        </div>
                        </th>
                        
                      {(can("/admin/babe-user/view") || can("/admin/babe-user/edit") || can("/admin/babe-user/delete")) && (
                        <th className="action_head">{t("list_heading_action")}</th>
                      )}
                    </tr>
                  </thead>
                  <tbody>
                    <>
                      {list.length ? (
                        list.map((row, i) => {
                          return (
                            <tr
                              key={i}
                            >
                              <td>
                                {row ? ((page - 1) * itemperpage) + i + 1 : null}
                              </td>

                              <td>{row?.name ? <div className="d-flex">{row?.name ? TrimText(capitalizeFirstLetter(row?.name), 20) : "N/A"}</div> : <div className="d-flex">N/A</div>}</td>
                              <td>{row?.email ? row.email : "N/A"}</td>

                              <td>{row?.address && row?.address.address ? TrimText(capitalizeFirstLetter(row?.address.address, 30)) : "N/A"} </td>

                              <td>{row?.phone_number ? row.phone_number : "N/A"}</td>
                          
                              <td>
                                <div  style={{display:'flex', justifyContent:'center' , alignContent:'center'}}>
                                  <label className={"custom-switch cp" + (row.status !== 1 ? " e_none" : "")}>
                                    <input className="custom-switch-input cp" type="checkbox" checked={row?.status === 1} onChange={(e) => changeStatusToggle(row)} />
                                    <span className="custom-switch-indicator cp"></span>
                                  </label>
                                </div>
                              </td>

                              {/* <td>
                                <div  style={{display:'flex', justifyContent:'center' , alignContent:'center'}}>
                                  <label className={"custom-switch cp" + (row.isUserDeactivated !== true ? " e_none" : "")}>
                                      <input className="custom-switch-input cp" type="checkbox" checked={row?.isUserDeactivated === true} onChange={(e) => changeActivationToggle(row)} />
                                      <span className="custom-switch-indicator cp"></span>
                                    </label>
                                </div>
                              </td> */}


                                  
                               
                            <td>
                             {row?.createdAt ? formatDateWithTime(row.createdAt) : "N/A"}
                             </td>
                              
                              {(can("/admin/babe-user/view") || can("/admin/babe-user/edit") || can("/admin/babe-user/delete")) && (
                                <td>

                                   <div className="btn-toolbar table-actions" role="toolbar" aria-label="Toolbar with button groups">
                                    <div className="btn-group btn-group-sm" role="group" aria-label="Second group">
                                      {can("/admin/babe-user/view") && (
                                        <Whisper placement="top" controlId="control-id-hover" trigger="hover" speaker={ <Tooltip style={{fontWeight:'bold'}}>View</Tooltip> }>
                                          <button type="button" className="btn view" onClick={() => { viewfunction(row); }}>
                                            <i className="ri-eye-fill"></i>
                                          </button>
                                        </Whisper>
                                      )}
                                      {can("/admin/babe-user/edit") && (
                                        <Whisper placement="top" controlId="control-id-hover" trigger="hover" speaker={<Tooltip style={{fontWeight:'bold'}}>Edit</Tooltip>}>
                                          <button type="button" className="btn edit" onClick={() => { goToEdit(row); }}>
                                            <i className="ri-pencil-fill"></i>
                                          </button>
                                        </Whisper>
                                      )}
                                      {can("/admin/babe-user/delete") && (
                                        <Whisper placement="top" controlId="control-id-hover" trigger="hover" speaker={<Tooltip style={{fontWeight:'bold'}}>Delete</Tooltip>}>
                                          <button type="button" className="btn delete" onClick={() => { Deletefunction(row) }}>
                                            <i className="ri-delete-bin-6-fill"></i>
                                          </button>
                                        </Whisper>
                                      )}
                                    </div>
                                  </div>
                                  
                                </td>
                              )}
                            </tr>
                          );
                        })
                      ) : (
                        <tr>
                          <td colSpan={14} className="text-center">
                            {t("msg_no_records")}
                          </td>
                        </tr>
                      )}
                    </>
                  </tbody>
                </table>
              </div>
              <div className="" id="example1_info" role="status" aria-live="polite">
                <b>
                  {t("msg_total_records")} : {datalength ? datalength : "0"}
                </b>
              </div>
              {datalength && datalength > 0 ? (
                <CustomPagination
                  datalength={datalength}
                  itemperpage={itemperpage}
                  currentPage={page}
                  setPage={setPage}
                  pageRoute={[
                    {
                      name: "Reataurant",
                      path: "/admin/babe-user/list",
                    },
                  ]}
                />
              ) : (
                ""
              )}
            </>
          }

          </div>
        </div>
      </div>

    </>
  );
};

export default BabeUserTable;


